import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IResponse } from '@bt/shared';
import { Withdrawal } from '../models/withdraw.model';

@Injectable()
export class WithdrawalService {

  constructor(private api: ApiService) { }

  public uriBuilder(): string {
    return "api/withdraw";
  }

   /**Получить все выводы*/ 
  public getAllWithdrawalsAsync(): Promise<IResponse<Withdrawal[]>> {
    return this.api.get<Withdrawal[]>(this.uriBuilder() + "/getAllWithdrawals").toPromise();
  }
/**получить инфу заблочен вывод или нет */
  public isExitsBlocked(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(this.uriBuilder() + "/exitsblocked").toPromise();
  }

   /**Создать неподтвержденный вывод*/ 
  public createWithdrawalAsync(model: Withdrawal): Promise<IResponse<number>> {
    return this.api.post<number>(this.uriBuilder() + "/createWithdrawal", model).toPromise();
  }

   /**Подтвердить вывод*/ 
  public confirmWithdrawlAsync(model: Withdrawal): Promise<IResponse<boolean>> {
    return this.api.post<boolean>(this.uriBuilder() + "/confirmWithdrawl", model).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/withdrawal.service.ts